<template>
  <div v-if="!lowResUrl" :style="styleObject" class="backgroundImage">
  </div>
  <BlurryImage v-else :lowResSrc="'/static/img/'+lowResUrl" :hiResSrc="'/static/img/'+url" type="background"></BlurryImage>
  </div>
</template>

<script>
import BlurryImage from './BlurryImage';

export default {
  name: 'BackgroundImage',
  data() {
    return {
    };
  },
  components: {
    BlurryImage,
  },
  props: {
    url: {
      default: '',
    },
    lowResUrl: { default: undefined },
    opacity: {
      default: 1,
    },
    color: {
      default: '#000',
    },
  },
  computed: {
    styleObject() {
      return {
        backgroundColor: this.color,
        backgroundImage: `url(/static/img/${this.url})`,
        opacity: this.opacity,
      };
    },
  },
};
</script>


<style lang="scss" scoped>
.backgroundImage {
  position: fixed;
  top: 0;
  left: 0;
  width:100%;;
  height: 100vh;
  z-index: -2;
  min-height: 100%;
  min-width: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

</style>



// WEBPACK FOOTER //
// BackgroundImage.vue?3034d7ea